import styles from "./InteractiveBadge.module.scss";

const label = "Interactive presentation";

/** Marks a post that holds an animation or 3D scene you can play with. Pure CSS, no state, cheap in a list. */
export default function InteractiveBadge() {
  return (
    <span className={styles.badge} data-tip={label} role="img" aria-label={label}>
      <span className={styles.ring} />
      <span className={styles.core} />
    </span>
  );
}
